<template>
  <div>
    <template v-if="!pending && opportunities.length">
      <div
        v-for="opportunity in opportunities"
        :key="opportunity._id"
        class="portfolio-opportunity"
      >
        <div class="dividend">
          <div>
            <span class="figure">
              {{ opportunity.dividend }}%
            </span>
            <span class="pa">
              p.a.
            </span>
          </div>
          <div class="name">
            {{ opportunity.title }}
          </div>
        </div>
        <div class="info">
          <h3>
            {{ opportunity.title }}
          </h3>
          <div v-html="opportunity.intro" />
        </div>
        <div class="actions">
          <base-button secondary :to="{ path: `/opportunities/${opportunity._id}/` }">
            Invest Now
          </base-button>
          <div class="mt-1">
            Capital at risk
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <base-loader />
    </template>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'PortfolioOpportunities',

  data: () => ({
    opportunities: []
  }),

  async created () {
    this.opportunities = await this.getOpportunities({
      investmentType: 'Portfolio'
    })
  },

  computed: {
    ...mapState({
      pending: store => store.core.investments.isOpportunitiesPending
    })
  },

  methods: {
    ...mapActions({
      getOpportunities: 'core/investments/opportunities'
    })
  }
}
</script>
